/**
 * The single number on a unit/bloco tab (MORADORES / VISITAS / PREST. / ENCOM. / EVENTOS).
 *
 * One per tab, deliberately. VISITAS used to carry up to three badges at once — the total, a
 * yellow one for people awaiting entry and a purple one for pré-cadastros — so the busiest tab
 * was also the only one whose numbers nobody could read without being told what they meant. The
 * states themselves are visible in the list the tab opens, which is where they can be labelled.
 */
export interface TabCountInput {
  isLoading: boolean;
  /** Rows the tab holds in total. */
  total: number;
  /** Rows left after the search box, when one is active. */
  filtered: number;
  isSearching: boolean;
}

export function tabCountLabel({ isLoading, total, filtered, isSearching }: TabCountInput): string {
  if (isLoading) return '…';
  // The denominator stays even when everything matches: "12/12" reads as "a search is on",
  // while a bare "12" would hide that the list is filtered at all.
  return isSearching ? `${filtered}/${total}` : String(total);
}
